<template>
    <v-container fluid class="user-list" v-if="languageData.products">
        <v-row class="ma-0">
            <v-card width="100%" class="ma-1 px-3 py-4">
                <v-card-text>
                    <v-row no-gutters align="center" width="100%">
                        <div class="search-input-container">
                            <v-text-field
                                class="search-input"
                                background-color="bgDefault"
                                height="55px"
                                single-line
                                flat
                                solo
                                hide-details
                                @keyup="filtersProducts"
                                v-model="searchProduct"
                                :placeholder="languageData.search"
                                :label="languageData.search"
                                prepend-inner-icon="mdi-magnify"></v-text-field>
                        </div>
                        <div class="search-button-container">
                        <v-btn height="55px" width="100%" class="search-button" color="primary" @click="openProductFormModal">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            {{ languageData.products.addProductBtn }}
                        </v-btn>
                        </div>   
                    </v-row>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-data-table
            loading-text="Loading... Please wait"
            class="users-table"
            :search="searchProduct"
            :headers="productsTableHeaders"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :items-per-page-options="rowsPerPageItems"
            :footer-props="footerOptions"
            :page.sync="currentPage"
            :items="products"
            :loading="loadingProducts"
            mobile-breakpoint="0"
            >
            <template v-slot:item.price="{ item }">
                <span>
                {{ item.price + '€' }}
                </span>
            </template>
            <template v-slot:item.uom="{ item }">
                <span>
                {{ languageData.measureTypes[item.uom] }}
                </span>
            </template>
            <template v-slot:item.vat="{ item }">
                <span>
                {{ item.vat + '%' }}
                </span>
            </template>
            <template v-slot:item.actions="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="editProduct(item)"
                    icon>
                    <v-icon color="fontDefault">edit</v-icon>
                </v-btn>
                </template>
                <span>{{ languageData.products.edit }}</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="showDeleteProductModal(item)">
                    <v-icon color="fontDefault">delete</v-icon>
                </v-btn>
                </template>
                <span>{{ languageData.products.delete }}</span>
            </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <ModalInfo v-if="isShowProductFormModal" :layout="'modalProductForm'" :hidden-agree-btn="true" @clicked="hideProductFormModal" :show-modal="isShowProductFormModal">
      <template v-slot:body>
        <ProductForm :layout="productFormLayout" :productData="activeProduct"></ProductForm>
      </template>
    </ModalInfo>
    <ModalInfo :headModal="productResponseModal.head" :btnAgreeText="'Ok'" :visDisAgreeBtn="false" @clicked="hideResponseProductModal" :show-modal="productResponseModal.isVisible" :text-modal="productResponseModal.textInfo"></ModalInfo>
    <ModalInfo @doOperation="deleteProduct" :isLoadingBtn="false" :headModal="deleteProductModal.head" :btnDisAgreeText="languageData.products.btnDisAgreeDeleteProductText" :btnAgreeText="languageData.products.btnAgreeDeleteProductText" :visDisAgreeBtn="true" @clicked="hideDeleteProductModal" :show-modal="deleteProductModal.isVisible" :text-modal="deleteProductModal.textInfo"></ModalInfo>
    </v-container>
</template>

<script>
import ModalInfo from "../../../../components/ModalInfo/ModalInfo.vue";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ProductForm from "../ProductForm/ProductForm.vue";
export default {
    name: "ProductsTable",
    components: {ModalInfo, ProductForm},
    data() {
        return {
            searchProduct: null,
            footerOptions: {
            'items-per-page-options': [20, 50, 100],
            'disablePagination': false
            },
            currentPage: 1,
            searchTask: null,
            searchDebouceTime: 500,
            isShowProductFormModal: false,
            productFormLayout: null,
            productResponseModal: {
                isVisible: false,
                head: null,
                textInfo: null,
            },
            deleteProductModal: {
                isVisible: false,
                head: null,
                textInfo: null
            },
            activeProduct: null,
        }
    },
    computed: {
        ...mapState("getProducts", {
            products: state => state.products,
            productsTableHeaders: state => state.productsTableHeaders,
            totalItems: state => state.pagination.totalItems,
            rowsPerPageItems: state => state.pagination.rowsPerPage,
            sortBy: state => state.pagination.sortBy,
            loadingProducts: state => state.loadingProducts
        }),
        pagination: {
            set: function(value) {
                this.searchProducts(value);
            },
            get: function() {
                return this.$store.state.getProducts.pagination;
            }
        }
    },
    methods: {
        ...mapActions("getProducts", ["getProductsRequest", "getProdutsHeadersTableRequest"]),
        ...mapActions("deleteProduct", ["deleteProductRequest"]),
        filtersProducts() {
            clearTimeout(this.searchTask);
            this.searchTask = setTimeout(() => {this.searchProducts({}, true)}, this.searchDebouceTime);
        },
        searchProducts(valueSearch={}, filters=false) {
            valueSearch.language = this.getCurrentLanguage;
            valueSearch.filters = filters;
            valueSearch.search = this.searchProduct;
            this.getProductsRequest(valueSearch);
            if(filters) {
                this.currentPage = 1;
            }
        },
        openProductFormModal() {
            this.productFormLayout = 'add',
            this.isShowProductFormModal = true;
        },
        hideProductFormModal() {
            this.isShowProductFormModal = false;
        },
        hideResponseProductModal() {
            this.productResponseModal.head = null;
            this.productResponseModal.textInfo = null;
            this.productResponseModal.isVisible = false;
        },
        editProduct(product) {
            this.activeProduct = product
            this.productFormLayout = 'edit',
            this.isShowProductFormModal = true;
        },
        showDeleteProductModal(product) {
            this.activeProduct = product
            this.deleteProductModal.head = this.languageData.products.deleteProductHead;
            this.deleteProductModal.textInfo = this.languageData.products.deleteProductTextInfo + ' ' + this.activeProduct.name;      
            this.deleteProductModal.isVisible = true;
        },
        hideDeleteProductModal() {
            this.deleteProductModal.isVisible = false;
        },
        deleteProduct() {
            this.deleteProductRequest(this.activeProduct);
        }
    },
    mounted() {
        this.updateLanguage(this.getCurrentLanguage);
        this.searchProducts({}, true);
        eventBus.$on("setDisablePagination", (value) => {
            this.footerOptions["disablePagination"] = value;
        });
        eventBus.$on('updateVisibleProductResponseModal', (head, textInfo) => {
            this.productResponseModal.head = head;
            this.productResponseModal.textInfo = textInfo;
            this.productResponseModal.isVisible = true;
        })
        eventBus.$on('saveProductSuccess', () => {
            this.productFormLayout = null,
            this.isShowProductFormModal = false;
            this.filtersProducts();
        });
        eventBus.$on('deleteProductSuccess', () => {
            this.activeProduct = null;
            this.filtersProducts();
        })
    },
}
</script>